import styled from '@emotion/styled';
import type { TSpinnerConfig } from './loader.types';

export const Container = styled.div`
	width: 50px;
	margin: 0 auto;
`;

export const Spinner = styled.div<TSpinnerConfig>`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	border: 5px solid rgba(${({ borderColorRGB }) => borderColorRGB || '255, 255, 255'}, 0.2);
	border-top-color: ${({ theme }) => theme.colors.primary1};
	animation: loader-spin 1000ms infinite linear;
	display: block;
	margin: 0 auto;
`;

export const WebMotorsContent = styled.div`
	transform: scale(0) translate(-50%, -50%);
	animation: show 0.3s cubic-bezier(0, 0.75, 0.41, 1.05) forwards;
	position: absolute;
	top: 50%;
	left: 50%;
	width: 50px;
	transform-origin: top center;

	@keyframes show {
		from {
			transform: scale(0) translate(-50%, -50%);
		}

		to {
			transform: scale(1) translate(-50%, -50%);
		}
	}

	svg {
		animation: rotate 1.5s infinite;
		will-change: transform;

		@keyframes rotate {
			0% {
				transform: rotate(0deg);
			}
			70% {
				transform: rotate(0deg);
			}
			80% {
				transform: rotate(190deg);
			}
			90% {
				transform: rotate(180deg);
			}
			100% {
				transform: rotate(180deg);
			}
		}
	}

	.st0 {
		fill: #b6061e;
	}

	.st1 {
		fill: none;
		stroke: #fff;
		stroke-width: 23;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-miterlimit: 10;
		stroke-dasharray: 600px;
		stroke-dashoffset: 600px;
		animation: path 1.5s linear infinite;

		@keyframes path {
			0% {
				stroke-dashoffset: 600px;
				opacity: 0.85;
			}

			55% {
				stroke-dashoffset: 0px;
				opacity: 0.85;
			}

			70% {
				stroke-dashoffset: 0px;
				opacity: 0.85;
			}

			80% {
				stroke-dashoffset: 0px;
				opacity: 0.85;
			}

			95% {
				stroke-dashoffset: 0px;
				opacity: 0;
			}

			100% {
				stroke-dashoffset: 0px;
				opacity: 0;
			}
		}
	}

	.st2 {
		fill: #ec0928;
	}

	.st3 {
		fill: #fff;
		stroke: #ddd;
		stroke-width: 1px;
		animation: circle 1.5s linear infinite;
		will-change: transform;

		@keyframes circle {
			0% {
				transform: translate(0px, 0px);
			}
			5.55% {
				transform: translate(0px, 84px);
			}
			11.1% {
				transform: translate(0px, 42px);
			}
			16.65% {
				transform: translate(57px, 42px);
			}
			22.2% {
				transform: translate(57px, -5px);
			}
			27.75% {
				transform: translate(57px, 94px);
			}
			33.3% {
				transform: translate(57px, 42px);
			}
			38.85% {
				transform: translate(113px, 42px);
			}
			44.4% {
				transform: translate(113px, 0px);
			}
			50% {
				transform: translate(113px, 84px);
			}
			100% {
				transform: translate(113px, 84px);
			}
		}
	}
`;
